// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 280 ? "sensors" : chunkId) + "." + {"280":"21a35a67","2161":"d5057822","8955":"e19bc8a5"}[chunkId] + ".chunk.js";
};